import { SessionStatus, SessionState } from '../types/session';

export const PERMISSIONS = {
  ENABLE_EVENT_COLLECTION_MACHINE: 'enable:auto_capture_collection',
};

export function hasPermission(
  sessionState: SessionState,
  ...permissions: Array<string>
): boolean {
  if (sessionState.status !== SessionStatus.LOGGED_IN) {
    return false;
  }

  return permissions.every((permission) =>
    sessionState.permissions.includes(permission),
  );
}
